'use client';
import { cache, useState } from 'react';
import { CasinoCategory } from './types';

import { useCasinoStoreActions } from '@/store';
import { getIcon } from '@/Icons';
import useBackend from '@/backend';

export const useGetCategories = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const { url } = useBackend();
	const { setCategories } = useCasinoStoreActions();
	const getCategories = cache(async () => {
		setLoading(true);
		setError(null);
		const apiUrl = `${url}/casino/get-categories`;
		// await new Promise((resolve) => setTimeout(resolve, 5000));
		try {
			const response = await fetch(apiUrl, {
				headers: {
					'Content-Type': 'application/json',
				},
				// next: { tags: ['game-categories'], revalidate: 60 },
				// next: { tags: ['game-categories'], revalidate: 60 },
				// cache: 'force-cache',
			});

			const categories = (await response
				.json()
				.then((res) => res?.data?.casinoCategories)) as CasinoCategory[];

			if (categories) {
				const formattedCategories = categories?.map((category) => {
					const iconKey = category?.name?.EN?.toLowerCase()
						.split('-')
						.join('')
						.replace(' ', '');
					const icon = getIcon(iconKey);

					return {
						...category,
						iconKey: iconKey,
						icon: icon,
					};
				});
				setCategories(formattedCategories);
			}
		} catch (e: unknown) {
			const message = e instanceof Error ? e.message : 'Unknown error';
			setError(message);
			if (e instanceof Error) return { user: null, error: e.message };

			return { user: null, error: 'Failed to load user data' };
		} finally {
			setLoading(false);
		}
	});
	return {
		loading,
		error,
		getCategories,
	};
};
